__turbopack_context__.v({
  "cta": "CtaGroup-module-scss-module__npoCeW__cta",
  "cta_group": "CtaGroup-module-scss-module__npoCeW__cta_group",
});
